import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'

function ProjectPageLink({ linkTo, children }) {
  const { m: isMobile } = useBreakpoint()

  if (isMobile) {
    return <>{children}</>
  }

  return (
    <Link to={linkTo} className="project-page-link">
      {children}
    </Link>
  )
}

ProjectPageLink.propTypes = {
  linkTo: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export default ProjectPageLink
